import { render, staticRenderFns } from "./V1FormBuilder.vue?vue&type=template&id=46312f91"
import script from "./V1FormBuilder.vue?vue&type=script&lang=js"
export * from "./V1FormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports